import {
  FormBuilderMetaFlags,
  IWidgetDirectiveType,
  WidgetType,
  isInputWidget,
} from '@framework/engine';
import { MapWidgetType } from '../../widgets/map/MapWidget.type';
import { ApplicantDataDirectiveConfigComponent } from './ApplicantDataDirectiveConfigComponent';
import {
  ApplicantDataDirectiveSchema,
  IApplicantDataDirective,
} from './IApplicantDataDirective';

export const ApplicantDataDirectiveType: IWidgetDirectiveType<IApplicantDataDirective> =
  {
    name: 'applicantData',
    key: 'applicantData',
    allowsWidget: (widget, widgetType) =>
      isInputWidget(widget) &&
      widget.type !== WidgetType.Repeatable &&
      widget.type !== MapWidgetType.type,
    configComponent: ApplicantDataDirectiveConfigComponent,
    configSchema: ApplicantDataDirectiveSchema,
    formSchemaModifier: ({ directiveConfig, schema, flags }) => {
      if (!directiveConfig.code) {
        console.warn(`[ApplicantDataDirectiveType] Missing name in config`);
        return schema;
      }

      if (flags[FormBuilderMetaFlags.SkipValidationRules]) {
        // Se le regole di validazione non sono attive, vuol dire che
        // non è il campo "principale" del Widget, quindi non dobbiamo
        // esportarlo.
        return schema;
      }

      // Salviamo il valore del campo da esportare nei meta, così da accedervi
      // in fase di estrazione
      return schema.meta?.({
        directiveApplicantData: directiveConfig.code,
      });
    },
  };
